var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 11,
    viewBox: "0 0 9 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.07631 5C6.84243 5 6.65262 4.79512 6.65262 4.54267V3.23348C6.65262 1.9554 5.68941 0.915737 4.5054 0.915737H4.4963C3.92407 0.915737 3.38797 1.15355 2.98292 1.5871C2.57504 2.02248 2.34964 2.60359 2.34738 3.22311V4.54267C2.34738 4.79512 2.15757 5 1.92369 5C1.68981 5 1.5 4.79512 1.5 4.54267V3.23348C1.50339 2.35541 1.81804 1.54502 2.38579 0.937689C2.95411 0.329749 3.70432 -0.0220972 4.50705 0.00107762C6.15668 0.00107762 7.5 1.45112 7.5 3.23348V4.54267C7.5 4.79512 7.31019 5 7.07631 5Z",
    fill: "#9D9D9D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 6C0 4.89543 0.895432 4 2 4H7C8.10457 4 9 4.89543 9 6V9C9 10.1046 8.10457 11 7 11H2C0.895432 11 0 10.1046 0 9V6ZM4.75 7.96849C5.1813 7.85748 5.5 7.46597 5.5 7C5.5 6.44771 5.05229 6 4.5 6C3.94771 6 3.5 6.44771 3.5 7C3.5 7.46597 3.8187 7.85748 4.25 7.96849V9H4.75V7.96849Z",
    fill: "#9D9D9D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.e4610394.svg";
export { ForwardRef as ReactComponent };